import {
    fetch
} from './fetch'

//获取邮箱等信息
export function getAboutUs() {
    return fetch({
        url: '/about/aboutOur',
        method: 'post'
    })
}
//获取导航（一二级）
export function getNavList() {
    return fetch({
        url: '/news_cate/getCate',
        method: 'post'
    })
}
//获取新闻列表
export function getNewsList(data) {

    return fetch({
        url: '/news/getNewsList',
        method: 'post',
        data: data
    })
}

//获取新闻详情
export function getNewsDetail(data) {
    return fetch({
        url: '/news/getNewsDetail',
        method: 'post',
        data:data
    })
}

//获取首页信息
export function getHomeInfo() {
    return fetch({
        url: '/index/homeList',
        method: 'post'
    })
}

//获取业务范围
export function getBusiness() {
    return fetch({
        url: '/business/scopeOfBusiness',
        method: 'post'
    })
}

//获取公司简介
export function getBrief() {
    return fetch({
        url: '/introduction/briefIntroduction',
        method: 'post'
    })
}

//关于我们头部
export function getAboutUsTitle(){
    return fetch({
        url: '/about/aboutOutTitle',
        method: 'post'
    })
}
